import React, { useState, useEffect, useMemo } from "react";
import Axios from "axios";
import AxiosTokenProvider from "axios-token-interceptor";
import useLocalStorage from "../useLocalStorage";
import { HOST_API } from "../../Api/API";
import { Row, Spin } from "antd";
import { MapKeysDefault } from "Templates/barraLateral/data/MapKeys";

const UsuarioContext = React.createContext();
export function UsuarioProvider(props) {
  const [usuario, setUsuario] = useState(null);
  const [cargandoUsuario, setCargandoUsuario] = useState(true);
  const [setLogin, getLogin] = useLocalStorage("login");
  const [barra, setBarra] = useState([]);
  const [rutasActivas, setRutasActivas] = useState([]);
  const [permisos, setPermisos] = useState([]);
  const [medicoData, setMedicoData] = useState({});
  useEffect(() => {
    recuperarUsuario();
    return () => {};
    //eslint-disable-next-line
  }, []);
  const recuperarUsuario = async () => {
    setCargandoUsuario(true);
    const store = getLogin();
    if (store && store.login) {
      setUsuario(store);
    }

    setCargandoUsuario(false);
  };

  useEffect(() => {
    getOpciones();
    getGalenhosMedico();
    return () => {};
    // eslint-disable-next-line
  }, [usuario]);

  const validateOpcion = (opcion) => {
    return Boolean(
      barra.find((x) => {
        if (!x.submenus) {
          return x.id === opcion;
        } else {
          return x.submenus.find((y) => {
            if (!y.submenus) {
              return y.id === opcion;
            } else {
              return y.submenus.find((z) => {
                return z.id === opcion;
              });
            }
          });
        }
      })
    );
  };

  const getOpciones = async () => {
    if (!usuario) {
      setBarra(MapKeysDefault);
    } else {
      const op = await askPOST("/api/opciones/listar/x-rol", {
        idRol: usuario.rol,
      });
      setBarra(op);
      const rts = await askPOST("/api/rutas/listar/x-rol", {
        idRol: usuario.rol,
      });
      setRutasActivas(rts);

      const p = await askPOST("/api/permisos-rol/listar", {
        idrol: usuario.rol,
      });
      setPermisos(p);
    }
  };

  const getGalenhosMedico = async () => {
    if (!usuario) {
      setMedicoData({});
    } else {
      const res = await Axios.post(`${HOST_API}/api/atenciones/medico/consulta-galenhos-medico`, { idUsuario: usuario.idEmpleado });
      if (res.data?.length) {
        setMedicoData(res.data[0]);
      } else {
        setMedicoData({});
      }
    }
  };

  const login = async (username, password) => {
    setCargandoUsuario(true);
    try {
      const res = await Axios.post(`${HOST_API}/login/`, {
        username: username,
        password: password,
      });
      const { token, user, idrol, idEmpleado, dni } = res.data;
      setLogin({
        login: true,
        store: token,
        login_username: user,
        rol: idrol,
        idEmpleado: idEmpleado,
        dni: dni,
      });
      recuperarUsuario();
      setCargandoUsuario(false);
      return ["AUTENTICACION CORRECTA", "Bienvenido al hospital " + user + "!", 200];
    } catch (error) {
      setCargandoUsuario(false);
      return ["AUTENTICACION INCORRECTA", "VERIFIQUE SU USUARIO Y CONTRASEÑA", 501];
    }
  };
  const logout = () => {
    localStorage.removeItem("login");
    sessionStorage.clear();
    setUsuario(null);
  };
  const askPOST = async (url, json) => {
    if (usuario !== null) {
      if (usuario.store !== null) {
        try {
          const instance = Axios.create({
            baseURL: HOST_API,
          });
          instance.interceptors.request.use(
            AxiosTokenProvider({
              getToken: () => usuario.store + " " + usuario.rol,
            })
          );
          const res = await instance.post(url, json);
          return res.data;
        } catch (error) {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const GET = async (url) => {
    if (usuario !== null) {
      if (usuario.store !== null) {
        try {
          const instance = Axios.create({
            baseURL: HOST_API,
          });
          instance.interceptors.request.use(
            AxiosTokenProvider({
              getToken: () => usuario.store + " " + usuario.rol,
            })
          );
          const res = await instance.get(url);
          return res.data;
        } catch (error) {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const uploadFile = async (url, selectedFile) => {
    if (usuario !== null) {
      if (usuario.store !== null) {
        if (selectedFile === "undefined" || selectedFile === null) {
          console.log("no cargo nada");
          return false;
        } else {
          try {
            const instance = Axios.create({
              baseURL: HOST_API,
            });
            instance.interceptors.request.use(
              AxiosTokenProvider({
                getToken: () => usuario.store + " " + usuario.rol,
              })
            );
            let formData = new FormData();
            formData.append("file", selectedFile, selectedFile.name);
            formData.append("name", "file");
            formData.append("id", "file");
            formData.append("file", "file");
            const res = await instance.post(url, formData);
            let data = res.data;
            return data;
          } catch (error) {
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const value = useMemo(() => {
    return {
      usuario,
      cargandoUsuario,
      login,
      logout,
      askPOST,
      uploadFile,
      GET,
      validateOpcion,
      barra,
      rutasActivas,
      permisos,
      medicoData,
    };
    //eslint-disable-next-line
  }, [usuario, cargandoUsuario, medicoData, barra, rutasActivas, permisos]);

  if (!cargandoUsuario) {
    return <UsuarioContext.Provider value={value} {...props} />;
  }
  return (
    <Row>
      <Spin />
      <span>Cargando usuario...</span>
    </Row>
  );
}
export function useUsuario() {
  const context = React.useContext(UsuarioContext);
  if (!context) {
    throw new Error("No se encontro Usuario en el contexto");
  }
  return context;
}
